<template>
  <v-dialog v-model="dialog" width="50vw">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom v-bind="attrs" v-on="on">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" x-small text @click.stop="dialog = true"
            ><v-icon small>mdi-message-outline</v-icon></v-btn
          >
        </template>
        <span> View Messaging </span>
      </v-tooltip>
    </template>

    <v-card class="primary--text" v-if="dialog">
      <v-card-title>
        {{ appointment.fullName }} {{ appointment.phoneNumber }}
        <v-spacer></v-spacer>
        <v-btn color="primary" icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <span
          v-if="noMessages"
          class="text-subtitle-1 font-italic d-flex justify-center pt-2"
          >No messages to display</span
        >
        <v-list-item
          v-for="(msg, i) in appointment.messages"
          :key="i"
          :class="Boolean(msg.sentAt) ? 'mr-14 pl-2' : 'ml-14 pr-2'"
        >
          <v-list-item-content>
            <v-card
              class="rounded-lg"
              :color="Boolean(msg.sentAt) ? 'blue lighten-3' : 'grey lighten-1'"
            >
              <v-card-text
                class="pa-2"
                :class="
                  Boolean(msg.sentAt)
                    ? 'primary--text'
                    : 'grey--text text--darken-4'
                "
              >
                {{ msg.content }}
              </v-card-text>
              <v-card-actions class="text-caption font-italic">
                {{
                  Boolean(msg.sentAt)
                    ? msg.formattedSentAt
                    : msg.formattedReceivedAt
                }}
              </v-card-actions>
            </v-card>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-center">
        <v-btn
          color="primary"
          small
          tile
          @click="sendReminder"
          :dark="!loading"
          :disabled="loading"
          >Send Reminder Now</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["appointmentId"],
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    appointment() {
      return this.$store.getters["appointmentsModule/getAppointmentById"](
        this.appointmentId
      );
    },
    noMessages() {
      return this.appointment.messages.length === 0;
    },
  },
  methods: {
    async sendReminder() {
      this.loading = true;
      var message = await this.$store.dispatch(
        "appointmentsModule/sendReminder",
        { mtaAppointmentId: this.appointment.mtaAppointmentId }
      );
      this.loading = false;

      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
    },
  },
};
</script>
